import React from "react";
import { AlertTriangle } from "lucide-react";

export const AuditWarningBanner = () => (
  <div
    data-testid="audit-warning-banner"
    className="flex items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    role="alert"
  >
    <AlertTriangle size={18} className="text-[#F57C00] shrink-0" />
    <span className="font-medium">You are approaching the DPDP compliance deadline.</span>
  </div>
);
